import { render, staticRenderFns } from "./step-register.vue?vue&type=template&id=09e52adc"
import script from "./step-register.vue?vue&type=script&lang=js"
export * from "./step-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports